export type IAgFormFirstSectionInterface = {
    TaxYear?: string;
    ApplicantOwnedPropertyJan1?: boolean
}

export const AgFormFirstSectionInitialState = (): IAgFormFirstSectionInterface => ({
    TaxYear: undefined,
    ApplicantOwnedPropertyJan1: undefined
})